import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import FormO2MFieldCombination from './Component/FormO2MFieldCombination.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form,ViewType.Detail],
    ttype: ModelFieldType.OneToMany,
    widget: 'FormO2MFieldCombinationWidget',
  })
)
export class MyFormO2MFieldCombinationWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(FormO2MFieldCombination);
    return this;
  }
}
